module.exports = __webpack_public_path__ + "img/Angiogenesis-CRC_CRLM.30b1c367.png";